const mFeedAssetsContentModalCreate = {
  mFeedAssetsContentModalCreate: {
    alerts: {
      createProyecto: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El curso fue creado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      titulo: {
        label: 'Escribe aquí un nombre',
        message: '* De 5 a 120 caracteres'
      }
    },

    title: 'Nuevo Curso',

    validation: {
      titulo: {
        maxLength: 'La longitud máxima permitida es de 120 caracteres.',
        minLength: 'La longitud mínima permitida es de 5 caracteres.',
        required: 'Nombre de curso es requerido. De 5 a 120 caracteres.'
      }
    }
  }
}

export default mFeedAssetsContentModalCreate
